module.exports = __webpack_public_path__ + "img/Medusa-LOGO.jpg";